<template>
<div>
    <div class="wrapper">
        <app-error-list/>
        <!-- 内容は以下に記述して下さい。 -->
        <info-section id="basic">
            <information-box title="次の要素技術に関する入力は、詳細入力画面で行います。">
                <ul>
                    <li>通風の利用</li>
                    <li>蓄熱の利用</li>
                    <li>床下空間を経由して外気を導入する換気方式の利用</li>
                    <li>電気ヒーター床暖房、ルームエアコンディショナー付温水床暖房機および温水床暖房</li>
                    <li>熱交換型換気設備</li>
                    <li>太陽光発電設備</li>
                    <li>液体集熱式太陽熱利用設備</li>
                    <li>空気集熱式太陽熱利用設備</li>
                    <li>コージェネレーション設備</li>
                </ul>
                <div class="message" style="padding-top:0;">
                    本画面（簡易入力画面）で入力した後に詳細入力画面に移動する（※）と、最小限の入力で上記の要素技術を計算できます。
                    <br/>
                    <span style="padding-left: 1em; font-size:0.8em;">※本画面（簡易入力画面）で入力した内容は、詳細入力画面に反映されます。</span>
                </div>
            </information-box>
        </info-section>
        <!-- 基本情報 -->
        <app-section>
            <h3 slot="h3">
                <parts-arrow category="基本情報">1</parts-arrow>
                <span>基本情報を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="住宅タイプの名称" 
                class="flex_column"
                @click="guideTransition"
                name="bsc_name"
            >
                <app-text
                    label=""
                    unit=""
                    v-model="bsc_name"
                    class="str90per"
                />
            </app-box>
            <app-box
                :available="true"
                label="住宅の建て方"
                class="flex_column"
                @click="guideTransition"
                name="bsc_tatekata"
            >
                <app-radio
                    v-for="(name, value) in master.bsc_tatekata"
                    v-model="bsc_tatekata"
                    :value="value"
                    unit=""
                    :key="'bsc_tatekata' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                :available="true"
                label="居室の構成"
                class="flex_column kyoshitsu_kousei"
                @click="guideTransition"
                name="bsc_kyoshitsu_kousei"
            >
                <app-radio
                    v-for="(name, value) in master.bsc_kyoshitsu_kousei"
                    v-model="bsc_kyoshitsu_kousei"
                    :value="value"
                    unit=""
                    :key="'bsc_kyoshitsu_kousei' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                label="その他の居室の有無"
                :available="true"
                v-if="bsc_kyoshitsu_kousei == '2'"
            >
                <app-radio
                    v-for="(name, value) in master.bsc_sonotakyoshitsu"
                    v-model="bsc_sonotakyoshitsu"
                    :value="value"
                    unit=""
                    :key="'bsc_sonotakyoshitsu' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                label="非居室の有無"
                :available="true"
                v-if="bsc_kyoshitsu_kousei == '2'"
            >
                <app-radio
                    v-for="(name, value) in master.bsc_hikyoshitsu"
                    v-model="bsc_hikyoshitsu"
                    :value="value"
                    unit=""
                    :key="'bsc_hikyoshitsu' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                :available="true"
                label="床面積"
                class="flex_column yuka_menseki"
                @click="guideTransition"
                name="bsc_nobeyuka_menseki"
            >
                <app-text
                    label="主たる居室"
                    unit="m2"
                    v-model="bsc_shukyoshitsu_menseki"
                    :step="0.01"
                    class="number"
                    subscript="(小数点以下2桁)"
                />
                <app-text
                    v-if="bsc_kyoshitsu_kousei == 1 || bsc_sonotakyoshitsu != 2"
                    label="その他の居室"
                    unit="m2"
                    v-model="bsc_sonotakyoshitsu_menseki"
                    :step="0.01"
                    class="number"
                    subscript="(小数点以下2桁)"
                />
                <app-text
                    label="合計"
                    unit="m2"
                    v-model="bsc_nobeyuka_menseki"
                    :step="0.01"
                    class="number"
                    subscript="(小数点以下2桁)"
                />
            </app-box>
            <app-box
                :available="true"
                label="地域の区分"
                class="flex_row env_chiki"
                @click="guideTransition"
                name="env_chiki"
                url="https://house.lowenergy.jp/program#solar_radiation_area"
                link-to="tool"
            >
                <app-radio
                    v-for="count in 8"
                    v-model="env_chiki"
                    :value="count.toString()"
                    label="1"
                    unit=""
                    :key="count"
                >
                    {{count}}地域
                </app-radio>
                <information-box title="令和1年11⽉16⽇に新しい地域区分が施⾏されました。">
                    <p>地域の区分は、<a href="https://house.lowenergy.jp/dictionary/basic#env_chiki" target="guide" class="target_blank">こちら</a>を参考に選択します。</p>
                </information-box>
            </app-box>
        </app-section>
        <!-- 外皮 -->
        <app-section id="envelope">
            <h3 slot="h3">
                <parts-arrow category="外皮">2</parts-arrow>
                <span>外皮性能の評価方法を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="外皮性能の評価方法" 
                class="flex_column"
                @click="guideTransition"
                name="ip_houhou"
            >
                <app-radio
                    v-for="(name, value) in master.ip_houhou"
                    v-model="ip_houhou"
                    :value="value"
                    unit=""
                    :key="'ip_houhou' + value"
                    :disabled="value >= 2 && tatekataChecker"
                >
                    {{name}}
                </app-radio>
            </app-box>
        </app-section>

        <!-- 外皮性能の評価方法＝1の時（当該住戸の外皮面積を用いて外皮性能を評価する） -->
        <app-section v-if="ip_houhou == 1">
            <h3 slot="h3">
                <parts-arrow category="外皮">3</parts-arrow>
                <span>
                    <parts-arrow class="line">2</parts-arrow>で「当該住戸の外皮面積を用いて外皮性能を評価する」を選択した場合、外皮の仕様を入力して下さい。
                </span>
            </h3>
            <app-box
                :available="true"
                label="外皮面積の合計" 
                class="flex_column"
                @click="guideTransition"
                name="bsc_sougaihi_menseki"
            >
                <app-text
                    label=""
                    unit="m2"
                    v-model="bsc_sougaihi_menseki"
                    min="1.00"
                    :step="0.01"
                    class="number"
                    subscript="(小数点以下2桁)"
                />
            </app-box>
            <app-box
                :available="true"
                label="外皮平均熱貫流率(U<sub>A</sub>)" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_value"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_value"
                    :step="0.01"
                    class="number"
                    subscript="(小数点以下2桁)"
                />
            </app-box>
            <app-box
                :available="true"
                label="冷房期平均日射熱取得率(η<sub>AC</sub>)" 
                class="flex_column"
                @click="guideTransition"
                name="ss_eta_value"
            >
                <app-text
                    label=""
                    unit=""
                    v-model="ss_eta_value"
                    :step="0.1"
                    class="number"
                    subscript="(小数点以下1桁)"
                />
            </app-box>
            <app-box
                :available="env_chiki != '8'"
                label="暖房期平均日射熱取得率(η<sub>AH</sub>)" 
                class="flex_column"
                @click="guideTransition"
                name="sw_eta_value"
            >
                <app-text
                    label=""
                    unit=""
                    v-model="sw_eta_value"
                    :step="0.1"
                    class="number"
                    subscript="(小数点以下1桁)"
                />
            </app-box>
        </app-section>

        <!-- 外皮性能の評価方法＝2の時（当該住戸の外皮面積を用いず外皮性能を評価する（別途計算）） -->
        <app-section v-if="ip_houhou == 2">
            <h3 slot="h3">
                <parts-arrow category="外皮">3</parts-arrow>
                <span>
                    <parts-arrow class="line">2</parts-arrow>で「当該住戸の外皮面積を用いず外皮性能を評価する（別途計算）」を選択した場合、外皮の仕様を入力して下さい。
                </span>
            </h3>
            <app-box
                :available="true"
                label="住戸の種類" 
                class="flex_row"
                @click="guideTransition"
                name="ip_yuka_dannetsu"
            >
                <app-radio
                    v-for="(name, value) in master.ip_yuka_dannetsu"
                    v-model="ip_yuka_dannetsu"
                    :value="value"
                    unit=""
                    :key="'ip_yuka_dannetsu' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                :available="true"
                label="外皮平均熱貫流率(U<sub>A</sub>)" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_value"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_value"
                    :step="0.01"
                    class="number"
                    subscript="(小数点以下2桁)"
                />
            </app-box>
            <app-box
                :available="true"
                label="冷房期平均日射熱取得率(η<sub>AC</sub>)" 
                class="flex_column"
                @click="guideTransition"
                name="ss_eta_value"
            >
                <app-text
                    label=""
                    unit=""
                    v-model="ss_eta_value"
                    :step="0.1"
                    class="number"
                    subscript="(小数点以下1桁)"
                />
            </app-box>
            <app-box
                :available="env_chiki != '8'"
                label="暖房期平均日射熱取得率(η<sub>AH</sub>)" 
                class="flex_column"
                @click="guideTransition"
                name="sw_eta_value"
            >
                <app-text
                    label=""
                    unit=""
                    v-model="sw_eta_value"
                    :step="0.1"
                    class="number"
                    subscript="(小数点以下1桁)"
                />
            </app-box>
        </app-section>

        <!-- 外皮性能の評価方法＝3の時（当該住戸の外皮面積を用いず外皮性能を評価する（ここで計算）） -->
        <app-section v-if="ip_houhou == 3">
            <h3 slot="h3">
                <parts-arrow category="外皮">3</parts-arrow>
                <span>
                    <parts-arrow class="line">2</parts-arrow>で「当該住戸の外皮面積を用いず外皮性能を評価する（ここで計算）」を選択した場合、外皮の仕様を入力して下さい。
                </span>
            </h3>
            <app-box
                :available="true"
                label="構造の種別" 
                class="flex_column"
                @click="guideTransition"
                name="ip_structure"
            >
                <app-radio
                    v-for="(name, value) in master.ip_structure"
                    v-model="ip_structure"
                    :value="value"
                    unit=""
                    :key="'ip_structure' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                :available="true"
                label="住戸の種類" 
                class="flex_column"
                @click="guideTransition"
                name="ip_house_dannetsu"
            >
                <app-radio
                    v-for="(name, value) in master.ip_house_dannetsu"
                    v-model="ip_house_dannetsu"
                    :value="value"
                    unit=""
                    :key="'ip_house_dannetsu' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                :available="isYukaDannetsu"
                label="浴室の断熱構造" 
                class="flex_column"
                @click="guideTransition"
                name="ip_bath_dannetsu"
            >
                <app-radio
                    v-for="(name, value) in master.ip_bath_dannetsu"
                    v-model="ip_bath_dannetsu"
                    :value="value"
                    unit=""
                    :key="'ip_bath_dannetsu' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                :available="true"
                label="屋根又は天井の熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_roof"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_roof"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                />
            </app-box>
            <app-box
                :available="true"
                label="壁の熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_wall"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_wall"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                />
            </app-box>
            <app-box
                :available="true"
                label="ドアの熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_door"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_door"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                />
            </app-box>
            <app-box
                :available="true"
                label="窓の熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_window"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_window"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                />
            </app-box>
            <app-box
                :available="isBathYukaDannetsu"
                label="浴室の床の熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_floor_bath"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_floor_bath"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="!isBathYukaDannetsu"
                />
            </app-box>
            <app-box
                :available="isYukaDannetsu"
                label="その他の床の熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_floor_other"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_floor_other"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="!isYukaDannetsu"
                />
            </app-box>
            <app-box
                :available="true"
                label="玄関等の基礎の熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_base_etrc"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_base_etrc"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                />
            </app-box>
            <app-box
                :available="ip_bath_dannetsu == 2 && ip_house_dannetsu != 2"
                label="浴室の基礎の熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_base_bath"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_base_bath"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="ip_bath_dannetsu != 2 || ip_house_dannetsu == 2"
                />
            </app-box>
            <app-box
                :available="isDomayuka"
                label="その他の基礎の熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_base_other"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_base_other"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="!isDomayuka"
                />
            </app-box>
            <app-box
                :available="true"
                label="玄関等の土間床等の外周部の線熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_psi_prm_etrc"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_prm_etrc"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                />
            </app-box>
            <app-box
                :available="isBathDomayuka"
                label="浴室の土間床等の外周部の線熱貫流率" 
                @click="guideTransition"
                name="ip_psi_prm_bath"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_prm_bath"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="!isBathDomayuka"
                />
            </app-box>
            <app-box
                :available="isDomayuka"
                label="その他の土間床等の外周部の線熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_psi_prm_other"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_prm_other"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="!isDomayuka"
                />
            </app-box>
            <app-box
                :available="!isMokuzou"
                label="屋根または天井の熱橋の線熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_psi_heatbridge_roof"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_heatbridge_roof"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="isMokuzou"
                />
            </app-box>
            <app-box
                :available="!isMokuzou"
                label="壁の熱橋の線熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_psi_heatbridge_wall"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_heatbridge_wall"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="isMokuzou"
                />
            </app-box>
            <app-box
                :available="!isMokuzou"
                label="床の熱橋の線熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_psi_heatbridge_floor"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_heatbridge_floor"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="isMokuzou"
                />
            </app-box>
            <app-box
                :available="!isMokuzou"
                label="屋根または天井と壁の熱橋の線熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_psi_heatbridge_roof_wall"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_heatbridge_roof_wall"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="isMokuzou"
                />
            </app-box>
            <app-box
                :available="!isMokuzou"
                label="壁と壁の熱橋の線熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_psi_heatbridge_wall_wall"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_heatbridge_wall_wall"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="isMokuzou"
                />
            </app-box>
            <app-box
                :available="!isMokuzou"
                label="壁と床の熱橋の線熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_psi_heatbridge_wall_floor"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_heatbridge_wall_floor"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="isMokuzou"
                />
            </app-box>
            <app-box
                :available="true"
                label="冷房期の窓の垂直面日射熱取得率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_ss_eta_d_window"
            >
                <app-text
                    label=""
                    unit="-"
                    v-model="ip_ss_eta_d_window"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                />
            </app-box>
            <app-box
                :available="env_chiki != '8'"
                label="暖房期の窓の垂直面日射熱取得率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_sw_eta_d_window"
            >
                <app-text
                    label=""
                    unit="-"
                    v-model="ip_sw_eta_d_window"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                />
            </app-box>
        </app-section>

        <!-- 暖房 -->
        <app-section id="heating">
            <h3 slot="h3">
                <parts-arrow category="暖房">4</parts-arrow>
                <span>暖房方式を入力して下さい。</span>
            </h3>
            <information-box title="「住戸全体を暖房する」の入力について">
                <ul>
                    <li>簡易入力画面における入力・計算機能を一時的に停止します。</li>
                    <li>詳細入力画面では、引き続き、入力・計算が可能です。再開までの間は、詳細入力画面をご利用ください。</li>
                </ul>
            </information-box>
            <app-box
                :available="true"
                label="暖房方式"
                class="flex_column"
                @click="guideTransition"
                name="hs_houhou"
            >
                <!-- モックに合わせてレイアウトの順番入れ替えています。仕様書と並び順が違うので注意 -->
                <app-radio
                    v-for="value in ['2', '1', '3']"
                    v-model="hs_houhou"
                    :value="value"
                    unit=""
                    :key="'hs_houhou' + value"
                    :disabled="value == '1'"
                >
                    {{master.hs_houhou[value]}}
                    <template v-slot:appendix>
                        <br />
                        <small v-if="value == '1'">（暖房設備機器はダクト式セントラル空調機＜ヒートポンプ式熱源＞として計算されます）</small>
                    </template>
                </app-radio>
            </app-box>
        </app-section>
        <app-section v-if="hs_houhou == 2">
            <h3 slot="h3">
                <parts-arrow category="暖房">5</parts-arrow>
                <span>
                    <parts-arrow class="line">4</parts-arrow>で「居室のみを暖房する」を選択した場合、暖房設備機器または放熱器の種類を入力して下さい。
                </span>
            </h3>
            <information-box title="電気ヒーター床暖房、ルームエアコンディショナー付温水床暖房機および温水床暖房について">
                <ul>
                    <li>詳細入力画面に移動して入力・計算を行います。</li>
                </ul>
            </information-box>
            <app-box
                :available="true"
                label="主たる居室の暖房設備機器または放熱器の種類"
                class="flex_column"
                @click="guideTransition"
                name="hs_ldk_type"
            >
                <div
                    v-for="(valueArray, index) in [['4','5'], ['6'], ['2','3'], ['9', '8']]"
                    class="boxinbox"
                    :key="'hs_ldk_type_box' + index"
                >
                    <span v-if="valueArray.includes('2')">温水暖房</span>
                    <div>
                        <div
                            v-for="value in valueArray"
                            :key="'hs_ldk_type' + value"
                        >
                            <app-radio
                                v-model="hs_ldk_type"
                                :value="value"
                                unit=""
                            >
                                {{master.hs_ldk_type[value]}}
                            </app-radio>
                            <app-radio-sub-box
                                label=""
                                v-if="hs_ldk_type == '9' && value == '9'"
                            >
                                <app-text
                                    label="その他の暖房設備機器の名称"
                                    unit=""
                                    v-model="hs_ldk_other_name"
                                    class=""
                                    subscript=""
                                />
                            </app-radio-sub-box>
                        </div>
                    </div>
                </div>
            </app-box>
            <app-box
                v-if="bsc_kyoshitsu_kousei == 1 || bsc_sonotakyoshitsu != 2"
                :available="true"
                label="その他の居室の暖房設備機器または放熱器の種類"
                class="flex_column"
                @click="guideTransition"
                name="hs_ldk_type"
            >
                <div
                    v-for="(valueArray, index) in [['4','5'], ['6'], ['2','3'], ['9', '8']]"
                    class="boxinbox"
                    :key="'hs_nldk_type_box' + index"
                >
                    <span v-if="valueArray.includes('2')">温水暖房</span>
                    <div>
                        <div
                            v-for="value in valueArray"
                            :key="'hs_nldk_type' + value"
                        >
                            <app-radio
                                v-model="hs_nldk_type"
                                :value="value"
                                unit=""
                            >
                                {{master.hs_nldk_type[value]}}
                            </app-radio>
                            <app-radio-sub-box
                                label=""
                                v-if="hs_nldk_type == '9' && value == '9'"
                            >
                                <app-text
                                    label="その他の暖房設備機器の名称"
                                    unit=""
                                    v-model="hs_nldk_other_name"
                                    class=""
                                    subscript=""
                                />
                            </app-radio-sub-box>
                        </div>
                    </div>
                </div>
            </app-box>
        </app-section>
        <app-section v-if="isOnsui">
            <h3 slot="h3">
                <parts-arrow category="暖房">6</parts-arrow>
                <span>
                    <parts-arrow class="line">5</parts-arrow>で「温水暖房」を選択した場合、温水暖房機の種類を入力して下さい。
                </span>
            </h3>
            <app-box
                :available="true"
                label="温水暖房機の種類"
                class="flex_column"
                @click="guideTransition"
                name="hs_onsuiyuka_netsugen_s"
            >
                <div
                    v-for="(valuesArray, index) in [['3','4','1','2','6','5','7'], ['11','13','14']]"
                    class="boxinbox"
                    :key="'hs_onsuiyuka_netsugen_senyo_box' + index"
                >
                    <span v-if="valuesArray.includes('3')">
                        温水暖房専用型
                    </span>
                    <div>
                        <div
                            v-for="value in valuesArray"
                            :key="'hs_onsuiyuka_netsugen_s' + value"
                        >
                            <app-radio
                                v-model="hs_onsuiyuka_netsugen_s"
                                :value="value"
                                unit=""
                            >
                                {{master.hs_onsuiyuka_netsugen_s[value]}}
                            </app-radio>
                            <hr v-if="['4', '2', '5'].includes(value)">
                        </div>
                    </div>
                </div>
                <information-box
                    title="給湯・温水暖房一体型について"
                    v-if="hs_onsuiyuka_netsugen_s == '11'"
                >
                    給湯タブで熱源機の種類を選択します。
                </information-box>
            </app-box>
        </app-section>

        <!-- 冷房 -->
        <app-section id="cooling">
            <h3 slot="h3">
                <parts-arrow category="冷房">7</parts-arrow>
                <span>冷房方式を入力して下さい。</span>
            </h3>
            <information-box title="「住戸全体を冷房する」の入力について">
                <ul>
                    <li>簡易入力画面における入力・計算機能を一時的に停止します。</li>
                    <li>詳細入力画面では、引き続き、入力・計算が可能です。再開までの間は、詳細入力画面をご利用ください。</li>
                </ul>
            </information-box>
            <app-box
                :available="true"
                label="冷房方式"
                class="flex_column"
                name="cs_houhou"
                @click="guideTransition"
            >
                <app-radio
                    v-for="value in ['2', '1', '3']"
                    v-model="cs_houhou"
                    :value="value"
                    unit=""
                    :key="'cs_houhou' + value"
                    :disabled="value == '1'"
                >
                    {{master.cs_houhou[value]}}
                    <template v-slot:appendix>
                        <br />
                        <small v-if="value == '1'">（冷房設備機器はダクト式セントラル空調機＜ヒートポンプ式熱源＞として計算されます）</small>
                    </template>
                </app-radio>
            </app-box>
        </app-section>
        <app-section v-if="cs_houhou == 2">
            <h3 slot="h3">
                <parts-arrow category="冷房">8</parts-arrow>
                <span>
                    <parts-arrow class="line">7</parts-arrow>で「居室のみを冷房する」を選択した場合、冷房設備機器の種類を入力して下さい。
                </span>
            </h3>
            <app-box
                :available="true"
                label="主たる居室の冷房設備機器の種類"
                class="flex_column"
                name="cs_ldk_type"
                @click="guideTransition"
            >
                <div
                    v-for="value in ['1', '3', '2']"
                    :key="'cs_ldk_type' + value"
                >
                    <app-radio
                        v-model="cs_ldk_type"
                        :value="value"
                        unit=""
                    >
                        {{master.cs_ldk_type[value]}}
                    </app-radio>
                    <app-radio-sub-box
                        label=""
                        v-if="cs_ldk_type == 3 && value == 3"
                    >
                        <app-text
                            label="その他の冷房設備機器の名称"
                            unit=""
                            v-model="cs_ldk_other_name"
                            class=""
                            subscript=""
                        />
                    </app-radio-sub-box>
                </div>
            </app-box>
            <app-box
                v-if="bsc_kyoshitsu_kousei == 1 || bsc_sonotakyoshitsu != 2"
                :available="true"
                label="その他の居室の冷房設備機器の種類"
                class="flex_column"
                name="cs_ldk_type"
                @click="guideTransition"
            >
                <div
                    v-for="value in ['1', '3', '2']"
                    :key="'cs_nldk_type' + value"
                >
                    <app-radio
                        v-model="cs_nldk_type"
                        :value="value"
                        unit=""
                    >
                        {{master.cs_nldk_type[value]}}
                    </app-radio>
                    <app-radio-sub-box
                        label=""
                        v-if="cs_nldk_type == 3 && value == 3"
                    >
                        <app-text
                            label="その他の冷房設備機器の名称"
                            unit=""
                            v-model="cs_nldk_other_name"
                            class=""
                            subscript=""
                        />
                    </app-radio-sub-box>
                </div>
            </app-box>
        </app-section>

        <!-- 換気 -->
        <app-section id="ventilation">
            <h3 slot="h3">
                <parts-arrow category="換気">9</parts-arrow>
                <span>換気設備の方式と換気回数を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="換気設備の方式"
                class="flex_column"
                name="vn_houshiki"
                @click="guideTransition"
            >
                <div
                    v-for="(name, value) in master.vn_houshiki"
                    :key="'vn_houshiki' + value"
                >
                    <app-radio
                        v-model="vn_houshiki"
                        :value="value"
                        unit=""
                    >
                        {{name}}
                    </app-radio>
                    <hr class="no_border" v-if="value == '2'">
                </div>
            </app-box>
            <app-box
                :available="true"
                label="換気回数 "
                class="flex_column"
                name="vn_freq"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.vn_freq"
                    v-model="vn_freq"
                    :value="value"
                    unit=""
                    :key="'vn_freq' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
        </app-section>
        <!-- 給湯 -->
        <app-section id="hotwater">
            <h3 slot="h3">
                <parts-arrow category="給湯">10</parts-arrow>
                <span>給湯設備・浴室等の有無を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="給湯設備・浴室等の有無"
                class="flex_column"
                name="hw_setti"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.hw_setti"
                    v-model="hw_setti"
                    :value="value"
                    unit=""
                    :key="'hw_setti' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
        </app-section>
        <app-section v-if="hw_setti == 1 || hw_setti == 2">
            <h3 slot="h3">
                <parts-arrow category="給湯">11</parts-arrow>
                <span>
                    <parts-arrow class="line">10</parts-arrow>で「給湯設備がある」を選択した場合、熱源機の種類を入力して下さい。
                </span>
            </h3>
            <app-box
                :available="true"
                label="熱源機の種類"
                class="flex_column"
                name="hw_shurui"
                @click="guideTransition"
            >
                <div
                    v-for="(valuesArray, index) in [['1','2','3','4','5','6','7'], ['11','12','13','14','15','16','17', '18'], ['22','23']]"
                    class="boxinbox"
                    :key="'hw_shurui_s_box' + index"
                >
                    <span v-if="valuesArray.includes('1')">
                        給湯専用型
                    </span>
                    <span v-else-if="valuesArray.includes('11')">給湯・温水暖房一体型</span>
                    <div>
                        <div
                            v-for="value in valuesArray"
                            :key="'hw_shurui_s' + value"
                        >
                            <app-radio
                                v-model="hw_shurui_s"
                                :value="value"
                                unit=""
                            >
                                {{master.hw_shurui_s[value]}}
                            </app-radio>
                            <hr v-if="['2','4','6','12','14','15'].includes(value)">
                        </div>
                    </div>
                </div>
                <information-box title="給湯専用型：電気ヒートポンプ・ガス瞬間式併用型給湯機および給湯・温水暖房一体型：電気ヒートポンプ・ガス瞬間式併用型給湯温水暖房機の入力について">
                    <p>以下に該当する場合、詳細入力画面での入力が必要になります。</p>
                    <ul>
                        <li>熱源機の種類が「給湯専用型：電気ヒートポンプ・ガス瞬間式併用型給湯機」または「給湯・温水暖房一体型：電気ヒートポンプ・ガス瞬間式併用型給湯温水暖房機（暖房部：ガス | 給湯部：電気ヒートポンプ・ガス）」で、冷媒の種類が「フロン系冷媒」かつタンクユニットの容量が「タンク容量（大）」であるか、または冷媒の種類が「プロパン系冷媒」である場合。</li>
                        <li>熱源機の種類が「給湯・温水暖房一体型：電気ヒートポンプ・ガス瞬間式併用型給湯温水暖房機（暖房部：電気ヒートポンプ・ガス | 給湯部：ガス）」で、タンクユニットの設置場所が「屋内に設置する」である場合。</li>
                        <li>熱源機の種類が「給湯・温水暖房一体型：電気ヒートポンプ・ガス瞬間式併用型給湯温水暖房機（暖房部：電気ヒートポンプ・ガス | 給湯部：電気ヒートポンプ・ガス）」で、ヒートポンプ・ガス瞬間式併用型給湯温水暖房機の区分が「区分2」である場合。</li>
                    </ul>
                </information-box>
            </app-box>
        </app-section>
        <app-section v-if="isBath">
            <h3 slot="h3">
                <parts-arrow category="給湯">12</parts-arrow>
                <span>
                    <parts-arrow class="line">10</parts-arrow>で「給湯設備がある」を選択した場合、ふろ機能の種類を入力して下さい。
                </span>
            </h3>
            <app-box
                :available="true"
                label="ふろ機能の種類"
                class="flex_column"
                name="hw_src_type"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name,value) in master.hw_src_type"
                    v-model="hw_src_type"
                    :value="value"
                    unit=""
                    :key="'hw_src_type' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
        </app-section>
        <!-- 照明 -->
        <app-section id="lighting">
            <h3 slot="h3">
                <parts-arrow category="照明">13</parts-arrow>
                <span>照明設備の評価方法を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="主たる居室の照明設備"
                class="flex_column"
                name="ls_main_setti"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.ls_main_setti"
                    v-model="ls_main_setti"
                    :value="value"
                    unit=""
                    :key="'ls_main_setti' + value"
                >
                    {{name}}
                </app-radio>
                <app-radio-sub-box
                    label="照明器具の種類"
                    name="ls_main_design"
                    @click="guideTransition"
                    v-if="ls_main_setti == 2"
                >
                    <app-radio
                        v-for="(name, value) in master.ls_main_design"
                        v-model="ls_main_design"
                        :value="value"
                        unit=""
                        :key="'ls_main_design' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-radio-sub-box>
            </app-box>
            <app-box
                v-if="bsc_kyoshitsu_kousei == 1 || bsc_sonotakyoshitsu != 2"
                :available="true"
                label="その他の居室の照明設備"
                class="flex_column"
                name="ls_general_setti"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.ls_general_setti"
                    v-model="ls_general_setti"
                    :value="value"
                    unit=""
                    :key="'ls_general_setti' + value"
                >
                    {{name}}
                </app-radio>
                <app-radio-sub-box
                    label="照明器具の種類"
                    name="ls_general_device"
                    @click="guideTransition"
                    v-if="ls_general_setti == 2"
                >
                    <app-radio
                        v-for="(name, value) in master.ls_general_device"
                        v-model="ls_general_device"
                        :value="value"
                        unit=""
                        :key="'ls_general_device' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-radio-sub-box>
            </app-box>
            <app-box
                v-if="bsc_hikyoshitsu == '1'"
                :available="true"
                label="非居室の照明設備"
                class="flex_column"
                name="ls_other_setti"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.ls_other_setti"
                    v-model="ls_other_setti"
                    :value="value"
                    unit=""
                    :key="'ls_other_setti' + value"
                >
                    {{name}}
                </app-radio>
                <app-radio-sub-box
                    label="照明器具の種類"
                    name="ls_other_device"
                    @click="guideTransition"
                    v-if="ls_other_setti == 2"
                >
                    <app-radio
                        v-for="(name, value) in master.ls_other_device"
                        v-model="ls_other_device"
                        :value="value"
                        unit=""
                        :key="'ls_other_device' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-radio-sub-box>
            </app-box>
        </app-section>

        <div class="flex_center column">
            <app-button
                value="簡易入力画面で計算する"
                id="calcEasy"
                this-class="btn_big btn_calc"
                @button-click="evaluate"
            />
        </div>
        <div class="flex_center column border aboutdetaile">
            <h2>詳細入力画面では以下の入力を行うことができます。</h2>
            <div class="flex_twin">
                <div>
                    <h4>簡易入力画面では扱いのない要素技術</h4>
                    <ul>
                        <li>通風の利用</li>
                        <li>蓄熱の利用</li>
                        <li>床下空間を経由して外気を導入する換気方式の利用</li>
                        <li>電気ヒーター床暖房、ルームエアコンディショナー付温水床暖房機および温水床暖房</li>
                        <li>熱交換型換気設備</li>
                        <li>太陽光発電設備</li>
                        <li>液体集熱式太陽熱利用設備</li>
                        <li>空気集熱式太陽熱利用設備</li>
                        <li>コージェネレーション設備</li>
                    </ul>
                </div>
                <div>
                    <h4>各種設備機器の詳細な仕様</h4>
                    <ul>
                        <li>
                            機器のエネルギー消費性能
                            <ul>
                                <li>エネルギー消費効率、定格能力・定格消費電力 など</li>
                            </ul>
                        </li>
                        <li>
                            各種省エネルギー手法・対策
                            <ul>
                                <li>
                                    <span class="ul_cathe">暖房</span>配管・配管経路の断熱（温水式の場合）など
                                </li>
                                <li>
                                    <span class="ul_cathe">暖房/冷房</span>VAV方式（住戸全体を暖房/冷房する場合） など
                                </li>
                                <li>
                                    <span class="ul_cathe">換気</span>直流モーター（ダクト式の場合）など
                                </li>
                                <li>
                                    <span class="ul_cathe">給湯</span>節湯水栓、浴槽の保温措置 など
                                </li>
                                <li>
                                    <span class="ul_cathe">照明</span>多灯分散照明方式、調光 など
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="red_box">簡易入力画面と詳細入力画面は、入力できる項目が異なりますが、プログラムは同じです。どちらの入力画面を使用しても設定条件が同じであれば、同じ計算結果が得られます。</div>
            <app-button
                value="詳細入力画面に移動する"
                @button-click="moveConfirm"
            />
            <span>このページで入力した内容を保持して詳細入力画面に移動します</span>
        </div>
        <div id="invisible"></div>
        <!-- 内容ここまで -->
    </div>
</div>
</template>

<script>
/**
 * 簡易版入力画面
 * 
 * [算出プロパティ]
 * error ... エラーの配列
 * 他は簡易版インタフェイス定義に準ずる
 * 
 * [ウォッチャ]
 * bsc_tatekata ... 住宅の建て方が「共同住宅」になった場合、外皮性能の評価方法は強制的に「当該住戸の外皮面積を用いて外皮性能を評価する」に変更
 * 
 * [イベント処理]
 * インタフェイス定義済み項目の更新時 ... Storeの該当するキーのデータも更新される
 * 計算ボタン押下時 ... 計算実行
 */
import evaluate from "@/mixins/eval"
import help from "@/mixins/help"
import master from "@/mixins/master"
import { mapGetters, mapActions } from 'vuex'
import { mapComputedProperties } from '@/util'

export default {
    name:"FormWrapper",
    computed: {
        ...mapGetters({
            data:'data/getData',
            error:'error/getError'
        }),
        ...mapComputedProperties([
            'bsc_name',
            'bsc_tatekata',
            'bsc_kyoshitsu_kousei',
            'bsc_sonotakyoshitsu',
            'bsc_hikyoshitsu',
            'bsc_shukyoshitsu_menseki',
            'bsc_sonotakyoshitsu_menseki',
            'bsc_nobeyuka_menseki',
            'env_chiki',
            'ip_houhou',
            'bsc_sougaihi_menseki',
            'ip_u_value',
            'ss_eta_value',
            'sw_eta_value',
            'ip_yuka_dannetsu',
            'ip_bath_dannetsu',
            'ip_u_value',
            'ss_eta_value',
            'sw_eta_value',
            'ip_structure',
            'ip_house_dannetsu',
            'ip_bath_dannetsu',
            'ip_u_roof',
            'ip_u_wall',
            'ip_u_door',
            'ip_u_window',
            'ip_u_floor_bath',
            'ip_u_floor_other',
            'ip_u_base_etrc',
            'ip_u_base_bath',
            'ip_u_base_other',
            'ip_psi_prm_etrc',
            'ip_psi_prm_bath',
            'ip_psi_prm_other',
            'ip_psi_heatbridge_roof',
            'ip_psi_heatbridge_wall',
            'ip_psi_heatbridge_floor',
            'ip_psi_heatbridge_roof_wall',
            'ip_psi_heatbridge_wall_wall',
            'ip_psi_heatbridge_wall_floor',
            'ip_ss_eta_d_window',
            'ip_sw_eta_d_window',
            'ip_window_f_input',
            'ip_window_ss_f',
            'ip_window_sw_f',
            'hs_houhou',
            'hs_ldk_type',
            'hs_ldk_other_name',
            'hs_nldk_type',
            'hs_nldk_other_name',
            'hs_onsuiyuka_netsugen_s',
            'hs_onsuiyuka_other_name',
            'cs_houhou',
            'cs_ldk_type',
            'cs_ldk_other_name',
            'cs_nldk_type',
            'cs_nldk_other_name',
            'vn_houshiki',
            'vn_freq',
            'hw_setti',
            'hw_shurui_s',
            'hw_other_name',
            'hw_src_type',
            'ls_main_setti',
            'ls_main_design',
            'ls_general_setti',
            'ls_general_device',
            'ls_other_setti',
            'ls_other_device'
        ]),
        tatekataChecker(){
            return this.bsc_tatekata == '2'
        },
        errorlist(){
            return this.error
        },
        isOnsui(){
            return this.hs_ldk_type == 1 || this.hs_ldk_type == 2 || this.hs_ldk_type == 3 || this.hs_nldk_type == 1 || this.hs_nldk_type == 2 || this.hs_nldk_type == 3
        },
        isYukaDannetsu(){
            return (this.ip_house_dannetsu == 1 || this.ip_house_dannetsu == 3)
        },
        isBathYukaDannetsu(){
            return (this.ip_house_dannetsu == 1 && this.ip_bath_dannetsu == 1 || this.ip_house_dannetsu == 3 && this.ip_bath_dannetsu == 1)
        },
        isBathDomayuka(){
            return (this.ip_house_dannetsu == 1 && this.ip_bath_dannetsu == 2 || this.ip_house_dannetsu == 3 && this.ip_bath_dannetsu == 2)
        },
        isDomayuka(){
            return (this.ip_house_dannetsu == 2 || this.ip_house_dannetsu == 3)
        },
        isMokuzou() {
            return this.ip_structure == 1
        },
        isBath(){
            const shuruiArray=['1', '2', '3', '4', '5', '6', '7', '11', '12', '13', '14', '15', '18', '21', '22']
            return this.hw_setti != 3 && shuruiArray.includes(this.hw_shurui_s)
        }
    },
    mixins:[evaluate, help, master],
    watch:{
        bsc_tatekata(newValue){
            if (newValue === '2') {
                this.ip_houhou = '1'
            }
        }
    },
    methods:{
        ...mapActions({
            update:'data/update',
            setMode:'mode/setMode',
            simpleToDetailShow:'view/simpleToDetailShow'
        }),
        moveConfirm () {
            this.simpleToDetailShow()
        }
    }
}
</script>

<style scoped>
/* 地域区分の項目部分にインフォメーションを表示 */
.env_chiki >>> .grid_2 {
    flex-flow: row wrap;
}
.env_chiki >>> .information {
    width:100%;
}

/*  ラジオボタンをグループ化する */
.app_box hr{
    margin-top: 1px;
    padding: 0;
    color: transparent;
    border: 1px solid transparent;
}
.boxinbox{
    display: -ms-grid;
    display: grid;
    grid-template-columns: minmax(0, 26px) 1fr;
    -ms-grid-columns: 26px 1fr;/* IE11 */
    padding-bottom: 12px;
}
.boxinbox>span{
    grid-column: 1;
    grid-row-start: 1; 
    grid-row-end: 20; 
    -ms-grid-column: 1;
    grid-row: 1;
    -ms-grid-row: 1;
    -ms-grid-row-span: 20;
    display: block;
    max-width: 16px;
    height: 100%;
    margin-right: 4px;
    padding-right: 4px;
    font-size: 12px;
    line-height: 13px;
    -webkit-writing-mode: vertical-rl;
      -ms-writing-mode: tb-rl;
          writing-mode: vertical-rl;
    border-right: 1px solid #ccc;
}
.boxinbox>div{
    grid-column: 2;
    -ms-grid-column: 2;
    display: flex;
    flex-direction: column;
}

.boxinbox>div hr{
    display: block;
}

/* ラジオボタン選択の見出し用 */
.gridinbox{
    display: -ms-grid;
    display: grid;
    grid-template-columns: minmax(0, auto) 1fr;
    -ms-grid-columns: auto 1fr;/* IE11 */
    padding-bottom: 12px;
}
.gridinbox:last-child{
    padding-bottom: 0;
}
.gridinbox>span{
    grid-column: 1;
    -ms-grid-column: 1;
    grid-row: 1 / 20;
    -ms-grid-row: 1;
    -ms-grid-row-span: 20;
    display: block;
    width: 9em;
    margin-right: 8px;
    padding-right: 8px;
    font-size: 12px;
    font-weight: bolder;
    line-height: 13px;
    border-right: 1px solid #ccc;
}
.gridinbox :not(span){
    grid-column: 2;
    -ms-grid-column: 2;
}
.gridinbox>div{
    grid-column: 2;
    -ms-grid-column: 2;
    grid-row: 1;
    -ms-grid-row: 1;
}
.gridinbox>div >>> label{
    display: block;
}
.wrapper >>> .btn_big{
    margin-top: 50px;
}

/* ボタンなどのボックス */
.flex_left{
    width: 90%;
    min-width: 900px;
    margin: 0 auto;
}
.flex_twin{
    display: flex;
    justify-content: space-around;
}
.flex_twin>div{
    display: block;
    width: 47%;
}
.flex_twin ul{
    padding-inline-start: 20px;
}
.flex_twin h4{
    border-bottom: 1px solid #41B8D4;
    letter-spacing: 0.05em;
}
.border{
    box-sizing: border-box;
    width: 80%;
    margin: 0 auto;
    padding: 1em 3.5em;
    border: 1px solid #ccc;
}
.border p{
    width: 100%;
    font-weight: bolder;
}
/* 個別のスタイル:原則、使いまわししない */
.yuka_menseki >>> .grid_2 label{
    display: inline-block;
    width: 7em;
}
.kyoshitsu_kousei >>> .radio_sub_box .label{
    display: inline-block;
    width: 8em;
}
.flex_twin {
    width: 100%;
    margin-bottom: 20px;
}
.flex_twin ul{
    padding-inline-start: 16px;
}
.flex_twin ul li{
    font-weight: bolder;
}
.flex_twin ul ul{
    padding-inline-start: 0;
}
.flex_twin ul ul li{
    font-weight: 500;
    list-style-type: none;
    margin-bottom: 4px;
    font-size: 12px;
}
.ul_cathe{
    display: inline-block;
    width: 5em;
    margin-right: 4px;
    padding: 0 4px;
    font-size: 10px;
    text-align: center;
    color: white;
    background-color: #777;
}
.red_box{
    display: block;
    width: 80%;
    margin: 4px auto;
    padding: 4px 8px;
    font-weight: bold;
    text-align: center;
    color: #F07466;
    border: 2px solid #F07466;
}
.aboutdetaile >>> input[type="button"].notyet{
    width: 15em;
    padding: 8px 16px;
    font-size: 14px;
    line-height: 16px;
    color: #ddd;
    background-color: #777;
    white-space: normal;
    cursor: default;
}
/* レスポンシブ（タブレット縦よりウインドウ幅が狭いもの） */
@media screen and (max-width: 1000px) {
    .flex_twin{
        flex-direction: column;
    }
    .flex_twin>div{
        width: 100%;
    }
    input.btn_calc{
        white-space: pre-wrap;
        margin: 16px 40px;
        font-size: 24px;
    }
    .border{
        width: 100%;
        padding: 16px;
    }
}

</style>

